<template>
    <div>
        <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
        <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
            <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una incidencia</option>
            <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las Incidencias</option>
            <option v-for="TipoIncidencia in TiposIncidencias" :value="TipoIncidencia.TipoIncidenciaId">{{TipoIncidencia.Nombre}}</option>        
        </select>      
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

export default {
  
    data() {
      return {
        enumeraciones,
        comun,
        TiposIncidencias: [],
        idDelModelo: null        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      //this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_SIAP_Catalogo_Establecer033TipoIncidencias", params);
    },
    methods: {
        cargarCatalogoIncidencias: function(){
            if(this.parametros == null || this.parametros == undefined)
            this.parametros = {}
            this.parametros.EsPrueba = this.enumeraciones.EsPrueba

            axios.post(api.conexion + api.SIAP.catalogos.C033TipoIncidencia, this.parametros)
            .then(respuesta => {
                if (respuesta.data.SiHayError) {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                this.TiposIncidencias = respuesta.data.GetTiposIncidencias;
                
                if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                    this.TiposIncidencias = respuesta.data.GetTiposIncidencias.filter(cond => this.parametros.filtros.some(incidencia => incidencia == cond.TipoIncidenciaId));
                }
                }
            })
            .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
            });
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const params = {
            llave: this.idDelInput,
            valor: evento.target.value
            }
            
            this.$store.dispatch("A_SIAP_Catalogo_Establecer033TipoIncidencias", params);
            this.$emit("valorParaElPadre", evento);        
        }
    },
    created() {
      this.cargarCatalogoIncidencias();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SIAP/Comun/Catalogos/033TipoIncidencias.vue